import type { IntakeAnswers, IntakeState } from './types';
import { INITIAL_ANSWERS } from './types';

/** Staff manual add-client: demographics only (episode/provider/scheduling live on Service Request Tracker). */
export const STAFF_ADD_CLIENT_STEPS = [5] as const;

export type StaffAddClientIntakeStep = (typeof STAFF_ADD_CLIENT_STEPS)[number];

export const STAFF_ADD_CLIENT_STEP_TITLES: Record<StaffAddClientIntakeStep, string> = {
  5: 'Client demographics',
};

export function getStaffAddClientInitialState(): IntakeState {
  return {
    answers: getStaffAddClientInitialAnswers(),
    activeStep: STAFF_ADD_CLIENT_STEPS[0],
    currentBookingRound: 0,
  };
}

export function getStaffAddClientInitialAnswers(): IntakeAnswers {
  return {
    ...INITIAL_ANSWERS,
    format: 'virtual',
    payType: 'cash',
    cashPaymentArrangedLater: true,
    preferredLocationIds: ['no-preference'],
    screeningEmergency: false,
    screeningHospitalization: false,
    screeningSuicidalIdeation: false,
    screeningMedications: false,
    screeningSubstanceUse: false,
    screeningLegalProceedings: false,
    emailVerified: true,
  };
}

export function staffStepIndexForIntakeStep(intakeStep: number): number {
  return STAFF_ADD_CLIENT_STEPS.indexOf(intakeStep as StaffAddClientIntakeStep);
}

export function nextStaffStep(intakeStep: number): StaffAddClientIntakeStep | null {
  const idx = staffStepIndexForIntakeStep(intakeStep);
  if (idx < 0 || idx >= STAFF_ADD_CLIENT_STEPS.length - 1) return null;
  return STAFF_ADD_CLIENT_STEPS[idx + 1];
}

export function prevStaffStep(intakeStep: number): StaffAddClientIntakeStep | null {
  const idx = staffStepIndexForIntakeStep(intakeStep);
  if (idx <= 0) return null;
  return STAFF_ADD_CLIENT_STEPS[idx - 1];
}

/** Provider grid and booking calendar need the wider modal layout. */
export function isStaffAddClientWideStep(_step: number): boolean {
  return false;
}
